export const PRIMARY_BASE  = 'https://hr-hiring-form.fusionlogics.com';
export const FALLBACK_BASE = 'https://dev-hr-hiring-form.fusionlogics.com';
const API_BASEURL = 'https://erp.fusionlogics.com/ords/api';

export const APP_CONFIG = {

  GET_TOKEN_URL:         `${PRIMARY_BASE}/get-token.php`,
  PROJECT_TYPE:          'HR_HIRING_FORM',
  TENANT_CONFIG_URL:     `${PRIMARY_BASE}/api-proxy.php?route=tenant-config`,
  BRANCHES_URL:          `${PRIMARY_BASE}/api-proxy.php?route=branches`,
  FILE_BASE_URL:         `${PRIMARY_BASE}/upload_files/`,
  UPLOAD_URL:            `${PRIMARY_BASE}/upload-cv.php`,
  APPLICATION_URL:       `${PRIMARY_BASE}/api-proxy.php?route=job-application`,
  HOST_URL:               window.location.origin,

};
export const API = {
  OAUTH_URL: `${API_BASEURL}/oauth/token`,
  APPLICATION_URL: `${API_BASEURL}/public_applicaitons_form/job_applications`,
  CLIENT_ID: "WyfUXilI7isLQvZnClyUMw..",
  CLIENT_SECRET: "pHNfwM5MMeDhTjUuSHUh4w..",
  FILE_BASE_URL: `${PRIMARY_BASE}/upload_files/`,
};
